<template lang="pug">
  .content.container.mx-auto(:class="[spacingTop, spacingBottom]", v-if="contents && contents.length" )
    .content-wrap.clearfix
      .img-text-wrap(:class="[{ 'float-text' : textFloat }, imagePosition]")
        Heading(v-if="imagePosition == 'top-block'" :class="headingPosition", :heading="heading.title", :subHeading="heading.sub_title")
        .image(v-if="images && images.length" ref="container")
          PostImage(
            v-for="image in images",
            :key="image.id",
            :content="image",
            :count="images.length",
            :max-width="containerWidth"
          )
        .content
            Heading(v-if="imagePosition != 'top-block'" :class="headingPosition", :heading="heading.title", :subHeading="heading.sub_title")
            .rte-area(v-if="content", v-html="content")
</template>

<script>
import { debounce } from '@/helpers';

import Heading from './Heading';
import PostImage from './PostImage';

export default {
    name: 'Post',
    data() {
        return {
            containerWidth: undefined
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Heading,
        PostImage
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        heading() {
            return this.contents.find(content => content.key === 'heading');
        },
        content() {
            let content = this.contents.find(content => content.key === 'content');
            if (content.text) content = content.text.replace('®', '<sup>®</sup>');
            return content;
        },
        images() {
            return this.contents.filter(content => content.key === 'image');
        },
        headingPosition() {
            let position = 'text-left';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'heading_position');
                if (setting && setting.value !== undefined) position = setting.value;
            }

            return position;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },
        imagePosition() {
            let position = 'left-float';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_position');
                if (setting && setting.value !== undefined) position = setting.value;
            }

            return position;
        },
        textFloat() {
            let textFloat = true;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_float');
                if (setting && setting.value !== undefined) textFloat = setting.value;
            }

            return textFloat;
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container);
                this.containerWidth = this.$refs.container.clientWidth;
                this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        };

        window.addEventListener('resize', debounce(calculateMaxWidth, 100));
        calculateMaxWidth();
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.content
  @apply mx-auto
  .content-wrap
    .img-text-wrap
        @screen md
           @apply flex flex-row
        .content
            .post-heading
                margin-top: -6px
            .rte-area
                //margin-top: -5px
        &.right-float,
        &.left-float
          .image
            @screen md
              @apply flex-shrink-0
              flex-basis: 320px
              width: 320px

        &.right-float
          .image
            @screen md
                @apply order-2 ml-8
          .content
            @screen md
                @apply order-1
        &.left-float .image
            @screen md
                @apply mr-8

    .img-text-wrap.float-text
      @apply block
      &.left-float .image
        @screen md
            @apply float-left mr-8
            padding-top: 6px
      &.right-float .image
        @screen md
            @apply float-right ml-8
            padding-top: 6px
</style>
